// This should be set inline by the template, but adding it here in case
// this script is loaded on a page it shouldn't be.
var site = window.site || {};
var generic = generic || {};
site.foundationFinder = site.foundationFinder || {};
site.foundationFinder.translations = site.foundationFinder.translations || {};
var page_data = page_data || {};
var rb = rb || {};
rb.language = rb.language || {};

site.foundationFinder.initResults = function(context, answers) {
  var maxResults = 3;
  if (site.foundationFinder.translations.maxResults) {
    if (site.foundationFinder.translations.maxResults > 0) {
      maxResults = site.foundationFinder.translations.maxResults;
    }
  }

  var signedIn = parseInt(site.userInfoCookie.getValue('signed_in'));
  //Without Signin to Cache question & answers
  if (!signedIn && answers) {
    site.foundationFinder.saveResults(context, signedIn, answers);
  }

  // Get results from sorted data
  if (answers !== undefined) {
    var getAnswer = new site.foundationFinder.GetPageData(answers);
  }

  // Get DOM Nodes:
  var $resultsWrapper = $('.ff-results', context);
  var $quizWrapper = $('.ff-quiz, .js-foundation-finder--quiz__carousel-wrapper', context);
  var $prodWrapper = $('.ff-results__recommended-products', $resultsWrapper);
  var $regWrappers = $('.ff-results__regimen-step', $resultsWrapper);
  var $prodCount = $('.ff-results__count', $resultsWrapper);

  var prodTemplate = $('script.ff-results__prod-template').html();
  var productAncillaryTemplate = $('script.ff-results__prod-ancillary-template').html();

  // Abbreviate vars
  var ff = site.foundationFinder;
  var trans = ff.translations;
  // only add the listener once
  $resultsWrapper.once('ff-results-listener', function() {
    $(document).on('foundation_finder_results:loaded', function(event, results) {
      _renderResults(results);
    });
  });
  function _shadeClick(event) {
    event.preventDefault();
    var $prod = $(this).parents('.sku-brief-editorial');
    var skuID = $(this).data('product-sku-base-id');
    var shade = $(this).data('product-shadename');
    var size = $(this).data('product-size');
    var prodID = $(this).data('product-id');
    var img = $(this).data('product-sku-medium-img');
    var prodImages = img.split(',');
    var $productLinks = $('.js-sku-brief-spp-link', $prod);
    var deepLinkShadeName = site.ShadePicker.prototype.fixedEncodeURIComponent(shade);

    // Apparently they're not the same thing.
    $('.js-add-to-cart', $prod).attr('data-sku-base-id', skuID);
    $('.sku-brief-editorial__shadename', $prod).text(shade);
    $('.sku-brief-editorial__size', $prod).text(size);
    $('.sku-brief-editorial__image', $prod).attr('src', prodImages[0]);

    $('.sku-brief-editorial__shade', $prod).removeClass('active');
    $(this).addClass('active');

    site.skuSelect({
      SKU_BASE_ID: skuID,
      PRODUCT_ID: prodID,
      SKU_ID: 'SKU' + skuID
    });
    if (Drupal.settings.globals_variables.enable_deep_link && $productLinks.length > 0) {
      $productLinks.attr('href', $productLinks.attr('href').split('#')[0] + '#/shade/' + deepLinkShadeName);
    }
  }
  function _destroyResults($prodWrapper) {
    if ($prodWrapper.hasClass('slick-initialized')) {
      $prodWrapper.slick('unslick');
    }
    $prodWrapper.empty();
  }

  function setupResultButtons(groupedProds) {
    var rendered = '';
    var $prod;
    var $productLinks;
    var deepLinkShadeName;

    groupedProds.forEach((prod) => {
      var sku = prod.skus[0];

      prod.first_medium_image = sku.MEDIUM_IMAGE[0];
      prod.first_sku_id = sku.SKU_BASE_ID;
      prod.first_shadename = sku.SHADENAME;
      prod.first_size = sku.PRODUCT_SIZE;
      prod.multiple_skus = prod.skus.length > 1;
      prod.display_options = prod.display_options || {};
      prod.display_options.hide_spp_link = 1;
      prod.display_options.show_review_count = 1;
      rendered = Mustache.render(prodTemplate, prod);
      $prod = $prodWrapper.append(rendered).children().last();
      $productLinks = $('.js-sku-brief-spp-link', $prod);
      prod.href = $productLinks.attr('href').split('#')[0];
      deepLinkShadeName = site.ShadePicker.prototype.fixedEncodeURIComponent(prod.first_shadename);
      site.createAddButton($('.js-add-to-cart', $prod));

      if (prod.multiple_skus) {
        $('.sku-brief-editorial__shade', $prod).on('click', _shadeClick).first().addClass('active');
      }

      if (Drupal.settings.globals_variables.enable_deep_link && $productLinks.length > 0) {
        $productLinks.attr('href', `${prod.href}#/shade/${deepLinkShadeName}`);
      }
    });
  }

  function _renderResults(rsp) {
    $quizWrapper.addClass('ff-quiz--edit collapsed');
    $('.ff-quiz__slide--content', $quizWrapper).hide();
    $('.ff-quiz__slide', $quizWrapper).removeClass('active');
    $('.ff-quiz__nav-item', $quizWrapper).removeClass('active');
    var prods = rsp;

    // Render product results
    _destroyResults($prodWrapper);

    // Group skus into their products:
    var prodIDs = {};
    var groupedProds = [];
    var inventoryStatus = [1, 2];
    for (var i = 0; i < prods.length; i++) {
      if (typeof prods[i][0].PRODUCT_ID !== 'undefined') {
        if ($.inArray(prods[i][0].skus[0].INVENTORY_STATUS, inventoryStatus > -1)) {
          if (typeof prodIDs[prods[i][0].PRODUCT_ID] == 'undefined') {
            groupedProds.push(prods[i][0]);
            prodIDs[prods[i][0].PRODUCT_ID] = groupedProds.length - 1;
          } else {
            groupedProds[prodIDs[prods[i][0].PRODUCT_ID]].skus.push(prods[i][0].skus[0]);
          }
        }
      }
    }

    var count = Math.min(groupedProds.length, maxResults);

    // Add the appropriate results count text
    var countText = count > 1 ? trans.countPlural : trans.countSingular;
    countText = countText.replace('%count', count);
    $prodCount.text(countText);

    var $prods = $('.ff-results__recommended-product', $prodWrapper);
    site.foundationFinder.equalHeights($prods);
    if ($quizWrapper.data('slickResults')) {
      $prodWrapper.find('.js-sku-brief-editorial__reviews--v3').removeClass('hidden');
      _initResultsSlider($prodWrapper);
    }
    $('.js-inv-status-list', $resultsWrapper).each(function() {
      var invStatusList = site.productView.InvStatusList($(this));
      $(this).on('inventory_status_updated', function(e) {
        e.stopPropagation();
        site.foundationFinder.allHeights();
      });
    });

    var productIds = site.productView.collectProductIds($resultsWrapper);
    if (productIds.length > 0) {
      site.productView.loadL2Data(productIds);
    }

    if (!site.client.isMobile) {
      site.foundationFinder.equalHeights($('.ff-results__regimen-step-headline', $resultsWrapper));
      site.foundationFinder.equalHeights($('.ff-results__regimen-step-instructions', $resultsWrapper));
      site.foundationFinder.equalHeights($('.ff-results__regimen-step-product', $resultsWrapper));
    }

    setupResultButtons(groupedProds);
  }

  function _initResultsSlider($slider) {
    var settings = {
      rtl: site.direction.isRTL,
      speed: 750,
      infinite: false,
      arrows: true,
      accessibility: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      initialSlide: 0,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            speed: 300,
          }
        },
      ]
    }
    $slider.slick(settings);
  }
  // Force slick to refresh:
  setTimeout(function() {
    $(window).trigger('resize');
  }, 500);
};

site.foundationFinder.allHeights = function() {
  var $prods = $('.ff-results__recommended-product');
  if ($prods.length) {
    site.foundationFinder.equalHeights($prods);
  }
  site.foundationFinder.equalHeights($('.ff-results__regimen-step-product'));
};

site.foundationFinder.equalHeights = function($els) {
  // These proportions are used across medium images:
  var imgWidth = 308;
  var imgHeight = 424;

  $els.height('auto');
  // Always set image heights:
  var $imgs = $('.sku-brief-editorial__image, .product_brief__image', $els);
  $imgs.height('auto').each(function() {
    $(this).height((imgHeight * $(this).width()) / imgWidth);
  });
  var heights = $.map($els, function(el) {
    return $(el).height();
  });
  $els.height(Math.max.apply(null, heights));
  $imgs.height('auto');
};

site.foundationFinder.GetPageData = function(answers) {
  this.init(answers);
};

site.foundationFinder.GetPageData.prototype = {
  answers: {},
  productData: {},
  skuData: [], //starts as an array
  results: [],
  resultProducts: [],
  getProductData: function(data) {
    var self = this;
    if (typeof page_data['custom-mpp']['products'] === 'undefined') {
      return false;
    } else {
      // deep clone
      self.productData = jQuery.extend(true, {}, page_data['custom-mpp']['products']);
    }

    var tempProducts = {};
    $.each(self.productData, function(index, product) {
      var productID = product['PRODUCT_ID'];
      if (product.hasOwnProperty(productID)) {
        tempProducts[productID].push(product);
      } else {
        tempProducts[productID] = product;
      }
    });

    self.productData = tempProducts;

    self.getSkuData();

    // coverage: "sheer",
    // finish: "semi-matte",
    // intensity: 1,
    // skin_type: "combination",
    // undertone:"neutral"
    // self.debugFields(self.productData, 'COVERAGE');
    // self.debugFields(self.productData, 'FINISH');
    // self.debugFields(self.skuData, 'SHADE_NUMBER');
    // self.debugFields(self.productData, 'SKIN_CONCERN_1');
    // self.debugFields(self.skuData, 'UNDERTONE');
  },
  getSkuData: function() {
    var self = this;

    // more deep copies
    var products = jQuery.extend(true, {}, self.productData);

    $.each(products, function(index, product) {
      var skus = product.skus;
      self.skuData.push(skus);
    });
    self.skuData = _.flatten(self.skuData);

    var tempSkus = {};
    $.each(self.skuData, function(index, sku) {
      var skuID = sku['SKU_ID'];
      // 1:1 relation, always equals sku
      tempSkus[skuID] = sku;
    });
    self.skuData = tempSkus;

    self.getResults();
  },
  debugFields: function(data, field) {
    var fieldResults = [];
    $.each(data, function(index, obj) {
      var val = data[index][field];
      fieldResults.push(val);
    });

    fieldResults = _.uniq(fieldResults);
  },
  testResults: function(data) {
    var self = this;
    $.each(data, function(index, sku) {
      var pass = 0;
      var prod = self.productData[sku['PRODUCT_ID']];

      // each answer
      $.each(self.answers, function(fieldName, fieldValue) {
        //turn into array
        switch (typeof fieldValue) {
          case 'string':
            self.answers[fieldName] = fieldValue.replace(/\s+/g, '').split(',');
            break;
          case 'number':
            self.answers[fieldName] = [fieldValue];
            break;
        }

        // uppercase fieldname
        var field;
        if (typeof fieldName == 'string') {
          field = fieldName.toUpperCase();
        } else {
          field = fieldName;
        }

        // some have more than one answer
        $.each(self.answers[fieldName], function(index, answer) {
          var pass = false;
          // lowercase to match answer
          var prodResult = typeof prod[field] == 'string' ? prod[field].toLowerCase() : prod[field];
          var skuResult = typeof sku[field] == 'string' ? sku[field].toLowerCase() : sku[field];

          // PROD LEVEL
          if (prodResult != null) {
            if (
              (typeof prodResult === 'string' && prodResult.indexOf(answer) !== -1)
              || (typeof prodResult === 'number' && prodResult === answer)
            ) {
              // match on the prod level
              pass = true;
            }
          }

          // SKU LEVEL
          if (skuResult != null) {
            if (
              (typeof skuResult === 'string' && skuResult.indexOf(answer) !== -1)
              || (typeof skuResult === 'number' && skuResult === answer)
            ) {
              // match on the sku level
              pass = true;
            }
          }
        });
      });
    });
  },
  formatProducts: function() {
    var self = this;
    // check if result skus have same parent prod
    var sortedResults = {};
    $.each(self.results, function(index, sku) {
      var productID = sku['PRODUCT_ID'];
      if (sortedResults.hasOwnProperty(productID)) {
        sortedResults[productID].push(sku);
      } else {
        sortedResults[productID] = [sku];
      }
    });

    $.each(sortedResults, function(productID, skus) {
      var product = self.productData[productID];
      // overwrite existing skus with result skus
      product.skus = skus;
      self.resultProducts.push([self.productData[productID]]);
    });

    // all done, render products
    // should re-write site.foundationFinder.initResults
    // using this event instead
    $(document).trigger('foundation_finder_results:loaded', [self.resultProducts]);
  },
  passFail: function(answer, result, skuID) {
    var returnPass = 0;
    if (result != null) {
      if (typeof result === 'string') {
        // normalize forward slash
        result = result.replace(/\//g, ',');
        answer = answer.toString(); // issue with split number reults
        if (result.indexOf(answer) !== -1) {
          if (result.indexOf(',') !== -1) {
            // might be comma seperated
            var commaResults = result.replace(/\s+/g, '').split(',');
            var check = 0;
            $.each(commaResults, function(index, commaResult) {
              // additionally, might have / seperator
              if (commaResult.indexOf(answer) === 0 && commaResult.length === answer.length) {
                check++;
              }
            });
            // tally
            if (check) {
              returnPass++;
            }
          } else {
            // not comma seperated
            if (result.indexOf(answer) === 0 && result.length === answer.length) {
              returnPass++;
            }
          }
        }
      } else if (typeof result === 'number') {
        if (result === answer) {
          returnPass++;
        }
      }
    }
    if (returnPass) {
      return true;
    } else {
      return false;
    }
  },
  getResults: function() {
    var self = this;
    var answerLength = _.keys(self.answers).length;
    var $overlayNoResultContainer = $('.js-overlay-noresult-message-container');

    // each sku
    // each answer
    // each part of the answer
    // add to results

    // each sku
    $.each(self.skuData, function(index, sku) {
      var pass = 0;
      var prod = self.productData[sku['PRODUCT_ID']];
      // each answer
      $.each(self.answers, function(fieldName, fieldValue) {
        if (typeof fieldValue == 'object') {
          fieldValue = fieldValue[0];
        }
        //turn into array
        switch (typeof fieldValue) {
          case 'string':
            self.answers[fieldName] = fieldValue.replace(/\s+/g, '').split(',');
            break;
          case 'number':
            self.answers[fieldName] = [fieldValue];
            break;
        }

        // uppercase fieldname
        var field;
        if (typeof fieldName == 'string') {
          field = fieldName.toUpperCase();
        } else {
          field = fieldName;
        }
        // some have more than one answer
        $.each(self.answers[fieldName], function(index, answer) {
          // lowercase to match answer
          var prodResult = typeof prod[field] == 'string' ? prod[field].toLowerCase() : prod[field];
          var skuResult = typeof sku[field] == 'string' ? sku[field].toLowerCase() : sku[field];
          if (self.passFail(answer, prodResult, sku['SKU_ID'])) {
            pass++;
          } else if (self.passFail(answer, skuResult, sku['SKU_ID'])) {
            pass++;
          }
        });
      });
      if (pass >= answerLength) {
        self.results.push(sku);
      }
    });

    self.testResults(self.results);

    var $noResultWrapper = $('.ff-results__no-results');
    var $otherResultWrapper = $('.ff-results__matches, .ff-results__recommendations');
    if (self.results.length) {
      $noResultWrapper.addClass('hidden');
      $otherResultWrapper.removeClass('hidden');
      self.formatProducts();
    } else {
      var $quizWrapper = $('.ff-quiz');
      $quizWrapper.addClass('ff-quiz--edit collapsed');
      $('.ff-quiz__slide--content', $quizWrapper).hide();
      $('.ff-quiz__slide', $quizWrapper).removeClass('active');
      $('.ff-quiz__nav-item', $quizWrapper).removeClass('active');
      $noResultWrapper.removeClass('hidden');
      $otherResultWrapper.addClass('hidden');
    }
  },
  init: function(answers) {
    var self = this;

    // reset
    self.answers = {};
    self.productData = {};
    self.skuData = [];
    self.results = [];
    self.resultProducts = [];

    answers.SKIN_CONCERN_1 = answers.skin_type;
    delete answers.skin_type;

    answers.SHADE_NUMBER = answers.intensity;
    delete answers.intensity;

    self.answers = answers;
    self.getProductData();
  }
};

site.foundationFinder.saveResults = function(context, isSignedIn, answers) {
  var $resultsWrapper = $('.js-ff-results', context);
  var $quizWrapper = $('.js-ff-quiz', context);
  var $overlayResultSuccessContainer = $('.js-overlay-success-message-container');
  var $overlayResultfailureContainer = $('.js-overlay-failure-message-container');
  var params = { type: 'foundation_finder' };
  if (!_.isEmpty(answers)) {
    params.answers = answers;
  } else if (isSignedIn) {
    $resultsWrapper.add($quizWrapper).addClass('loading');
  }

  generic.jsonrpc.fetch({
    method: 'quiz.get_answers_and_results',
    params: [params],
    onBoth: function(jsonRpcResponse) {
      $resultsWrapper.add($quizWrapper).removeClass('loading');
      var rsp = jsonRpcResponse.getValue();
      // Do not render anything if there are no results
      var hasAnswers = rsp.answers != null;
      $('.ff-results__recommended-products').removeClass('hidden', !hasAnswers);
      if (hasAnswers) {
        if (isSignedIn) {
          $.each(rsp.answers, function(question, answer) {
            var $q = $('.ff-quiz__question', $quizWrapper).filter('[data-question-key=' + question + ']');
            var $a = $('.ff-quiz__answer[data-answer-key=' + answer + ']', $q);
            if (!$a.length) {
              $a = $('.ff-quiz__answer[data-answer=' + answer + ']', $q);
            }
            $a.trigger('click');
          });
        }
        if (_.isEmpty(answers)) {
          new site.foundationFinder.GetPageData(rsp.answers);
        }
      }
    },
    onFailure: function(jsonRpcResponse) {}
  });
};

$(function() {
  if (!site.client.isMobile) {
    $(window).on('resize', function() {
      site.foundationFinder.allHeights();
    });
    $(window).on('load', function() {
      site.foundationFinder.equalHeights($('.ff-results__regimen-step-product'));
    });
  }
});

(function($) {
  Drupal.behaviors.ffResults = {
    attach: function(context, settings) {
      //test data

      // 1. coverage = COVERAGE // sheer, medium, full
      // 2. finish = FINISH // Luminous, Radiant Glow, Semi-Matte, Matte
      // 3. skin_type = SKIN_CONCERN_1// Dry, Normal/Combination, Oily
      // 4. intensity = INTENSITY/SHADE_NUMBER 1:1 pulled from translation set
      // 5. undertone = UNDERTONE

      // shade_number is used to map SKIN_CONCERN_1

      // test data
      // var getAnswer = new site.foundationFinder.GetPageData({
      //   coverage: "sheer", // 1. How much coverage do you want?
      //   finish: "luminous", // 2. What kind of finish are you looking for?
      //   intensity:7, // 4. How light or deep is your skin intensity?
      //   skin_type:"combination", // 3. How would you describe your skin?
      //   undertone:"neutral" //5. How rosy or golden is your bare skin?
      // });

      // intensity should be a string 'light-medium'
      // shade_number should be a number

      var $noResultWrapper = $('.ff-results__no-results', context);
      var signedIn = parseInt(site.userInfoCookie.getValue('signed_in'));
      var answers = {};
      if (signedIn) {
        site.foundationFinder.saveResults(context, signedIn, answers);
        $('.js-launch-account--return').removeClass('js-launch-account').addClass('js-save-profile');
      }
      $('.js-save-profile', context).on('click', function() {
        var $quiz = $('.js-ff-quiz', context);
        var $questions = $('.js-ff-quiz-question', $quiz);
        $questions.each(function() {
          var $answer = $('.js-ff-quiz-answer.active', this);
          var answerKey = $answer.data('answer-key') || $answer.data('answer');
          answers[$(this).data('question-key')] = answerKey;
        });
        site.foundationFinder.saveResults(context, signedIn, answers);
      });
      site.foundationFinder.initResults(context);
    }
  };
})(jQuery);
